<script>
  import Icon from "$lib/components/Icon.svelte";
  import Link from "$lib/components/Link.svelte";
  import ResponsiveColumn from "$lib/components/ResponsiveColumn.svelte";
  import MenuTrigger from "./MenuTrigger.svelte";
  import MenuItem from "../MenuItem.svelte";
  import { isExternalUrl } from "$lib/utilities/url-helpers";
  import ExternalLinkLabel from "$lib/components/ExternalLinkLabel.svelte";

  export let data;
  export let isOpen = false;

  let label = data.fields.headerText || data.fields.text || data.fields.name;
  let menuId = `menu-${data.sys.id}`;
  let menuLabelId = `menu-label-${data.sys.id}`;

  // on desktop, menu is static; on mobile, menu is a collapsable dropdown
  let windowInnerWidth;
  $: isMobile = windowInnerWidth < 1366;
  $: menuProps = isMobile ? { role: "menu" } : {};
  $: menuTriggerProps = isMobile
    ? {
        menuId,
        isOpen,
        haspopup: true
      }
    : { menuLabelId };
  $: menuItemProps = isMobile ? { role: "menuitem" } : {};

  function handleWindowKeyDown(event) {
    if (event.key === "Escape") {
      isOpen = false;
    }
  }
</script>

<svelte:window bind:innerWidth={windowInnerWidth} on:keydown={handleWindowKeyDown} />

<ResponsiveColumn>
  <div class="my-3">
    <MenuTrigger {label} on:click {...menuTriggerProps} />
    <h4 class="sr-only" id={menuLabelId}>
      {label}
    </h4>

    {#if data.children}
      <ul
        class="list-none lg:px-0 bg-indigo-50 border-b-2 border-neutral-300 lg:bg-white lg:border-0"
        class:hidden={!isOpen}
        class:lg:block={true}
        id={menuId}
        aria-labelledby={menuLabelId}
        {...menuProps}
      >
        {#each data.children as child}
          <li {...menuItemProps} aria-label={child.text}>
            <Link
              url={child.destination?.fields?.url || child.url}
              class="hidden lg:block !text-size-12 md:!text-size-14 !px-0 !py-8"
              text={child.text}
            />
            <MenuItem
              url={child.destination?.fields?.url || child.url}
              isViewAllLink={child.type === "viewAllLink"}
              class="lg:hidden px-0 active:shadow-dropdown-hover"
            >
              <span class="self-center">
                {#if isExternalUrl(child.destination?.fields.url) || isExternalUrl(child.url)}
                  <ExternalLinkLabel
                    text={child.text}
                    iconClass="inline"
                    iconSize="sm"
                    textClass="no-underline"
                  />
                {:else}
                  {child.text}
                {/if}
              </span>
              <span class="left"><Icon type="chevron-right" class="block" /></span>
            </MenuItem>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
</ResponsiveColumn>
